<template>
  <div class="list-form__item">
    <slot
      name="first-of-group"
      :data="data"
      :item="item"
    >
    </slot>
    <slot
      :data="data"
      :item="item"
      :updateDataItem="updateDataItem"
      :updateModelItem="onUpdateModelItem"
      :autoSave="onAutoSave"
      :handleCommand="handleCommand"
      :permissionControls="permissionControls"
    >
    </slot>
    <div>
      <form-controls
        v-if="isVisibleControls"
        :isDelete="isDelete"
        :isSave="isSave"
        @command="handleCommand"
      >
      </form-controls>
    </div>
    <slot
      name="last-of-group"
      :data="data"
      :item="item"
    >
    </slot>
  </div>
</template>

<script>
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
import { AutoSaveMixin } from '@/mixins/FormAutoSave'

export default {
  name: 'ListFormItem',
  mixins: [FormWrapperAutoSave, AutoSaveMixin],
  props: {
    model: { type: Object },
    data: { type: Object }, // origin data item
    item: { type: Object },
    formModel: { type: Function, default: () => ({}) },
    isAutoSave: { type: Boolean, default: true },
    autoSaveUrl: { type: [String, Function] },
    isVisibleControls: { type: Boolean, required: true },
    permissionControls: { type: Object }
  },
  components: {
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  data () {
    return {
      apiPatch: this.autoSaveUrl
    }
  },
  computed: {
    isDelete () {
      return this.permissionControls.delete
    },
    isSave () {
      return this.permissionControls.save
    },
    isAvailableToSave () {
      return this.isAutoSave
    },
    currentID () {
      return this.data[this.model.store.mainField]
    },
    apiAutoSave () {
      return this.checkEs6AndRun(this.apiPatch, { ...this.item })
    }
  },
  methods: {
    // SLOT INTERFACE
    handleCommand (command) {
      this.$emit('commandControl', command, Object.assign({ id: this.currentID }, this.item))
    },
    updateDataItem (item) {
      this.$emit('updateDataItem', this.currentID, Object.assign({ id: this.currentID }, item))
    },
    onUpdateModelItem (fieldName, value, config) {
      this.handlerUpdateModelItem(fieldName, value, { id: this.currentID, ...config })
    },
    handlerSuccessUpdateModelQueue (payload) {
      this.$emit('onPatch', payload)
    },
    async onAutoSave (config) {
      return this.mixAutoSave(config)
    },
    getFormData () {
      return this.item
    },
    mixSuccessAutoSave (_data) {
      this.$emit('onAutoSaveSuccess', { ...this.item, ..._data })
    },
    mixErrorAutoSave (err) {
      this.$emit('onAutoSaveError')
      this.requestErrorHandler(err)
    }
  }
}
</script>
